/**
 * @generated SignedSource<<d4059184a6728443a59bbe81f2ca7a0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "StemTransferResponse",
    "kind": "LinkedField",
    "name": "stmApply",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hash",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmStmApplyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmStmApplyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b342ee5dc05769d6e7ff1762c484d021",
    "id": null,
    "metadata": {},
    "name": "confirmStmApplyMutation",
    "operationKind": "mutation",
    "text": "mutation confirmStmApplyMutation(\n  $request: StmRequestInput\n) {\n  stmApply(request: $request) {\n    hash\n  }\n}\n"
  }
};
})();

node.hash = "5112b57424d14c2673f787469e8b259c";

module.exports = node;
